import React, { useState } from "react";
import Image from "next/image";
import VoteButtonsMini from "components/card//VoteButtonsMini";
import useAuth from "hooks/auth/useAuth";
import usePredictorVotes from "hooks/predictors/usePredictorVotes";

const PredictorCard = ({ predictor }) => {
  const { handleVote } = usePredictorVotes();
  const { currentUser } = useAuth();
  const [currentCard, setCurrentCard] = useState(predictor);
  return (
    <div
      style={{ boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.10)" }}
      className="flex flex-col items-center gap-[12px] py-[48px] px-[24px] rounded-[24px] bg-white w-full h-full"
    >
      <div className="flex flex-col md:flex-row gap-[24px] justify-between">
        <div className="flex flex-col gap-[12px] bg-center">
          <div className="w-[184px] h-[184px]">
            <Image
              width={0}
              height={0}
              sizes="100vh"
              src={currentCard.image || "/default_video.webp"}
              alt="person"
              priority
              className="rounded-[24px] bg-no-repeat object-cover w-[184px] h-[184px]"
            />
          </div>
          <div className="flex justify-between items-center">
            <span className="text-[#212121] text-[14px] font-[700] w-[100px]">
              {currentCard.firstName} {currentCard.lastName}
            </span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1"
              height="20"
              viewBox="0 0 1 20"
              fill="none"
            >
              <path
                d="M0.5 1.0238L0.500001 18.9763"
                stroke="#999999"
                strokeLinecap="round"
              />
            </svg>
            <span className="text-[#00BE95] text-[20px] font-[500]">
              {currentCard.points}
            </span>
          </div>
        </div>
      </div>
      <VoteButtonsMini
        currentUser={currentUser}
        state={currentCard.votes?.[currentUser?.uid] || ""}
        onChange={(state) => {
          handleVote(currentCard.id, currentUser?.uid, state);
          setCurrentCard((prev) => ({
            ...prev,
            votes: {
              ...prev.votes,
              [currentUser.uid]: state,
            },
          }));
        }}
      />
    </div>
  );
};

export default PredictorCard;
